// import { useState } from 'react';
// // import './App.css';
// import React from 'react';
// import LoginPage from './Component/LoginPage/LoginPage';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import ItemPage from './Component/itemPage/ItemPage';
// import Dashboard from './Component/Dashboard/dashboard';
// import store from './Component/ReduxStore/store';
// import { Provider } from 'react-redux';
// import Checkout from './Component/checkout/Checkout';
// import LeadgerStatement from './Component/leadgerStatement/LeadgerStatement';
// import OutGoingPayment from './Component/OutGoingPayment/outGoingPayment';
// import CustomerCreation from './Component/customerCreation/customerCreation';
// import Attendance from './Component/attendance/attendance';
// import CRM from './Component/crm/crm';
// import AutoLogout from './Component/sharedFiles/autoLogout';
// import CustomerFollowups from './Component/FollowUps/CustomerFollowups';
// import Opportunity from './Component/FollowUps/Opportunity';
// import SqHistory from './Component/SQHistory/sqHistory';
// import Greeter from './Component/Greeter/Greeter';

// function App() {
//   const [databaseName, setDatabaseName] = useState(null); 
//   return (
//     <>
//       {/* provide the database name */}
//       <Provider store={store}>
//     <Router basename="/TpSales">
//     <AutoLogout>
//     <Routes>
//         <Route path="/" element={<LoginPage/>} />
//         <Route path="/DashBoard" element={<Dashboard/>} />
//         <Route path="/GetGroupItem" element={<ItemPage/>} />
//         <Route path="/Checkout" element={<Checkout/>} />
//         <Route path="/leadgerStatement" element={<LeadgerStatement/>} />
//         <Route path="/OutGoingPayment" element={<OutGoingPayment/>} />
//         <Route path="/CustomerCreation" element={<CustomerCreation/>} />
//         <Route path="/MarkAttendance" element={<Attendance/>} />
//         <Route path="/Crm" element={<CRM/>} />
//         <Route path="/CustomerFollowups" element={<CustomerFollowups/>} />
//         <Route path="/Opportunity/:opprId" element={<Opportunity />} />
//         <Route path="/SqHistory" element={<SqHistory/>} />
//         <Route path="/Greeter" element={<Greeter/>} />

//         {/* other routes... */}
//     </Routes>
//     </AutoLogout>
//   </Router>
//   </Provider>
//   </>
//   );
// }
// document.addEventListener('DOMContentLoaded', () => {
//   const scrollbars = document.querySelectorAll('::-webkit-scrollbar');
//   scrollbars.forEach(scrollbar => {
//     scrollbar.addEventListener('mouseenter', () => {
//       scrollbar.classList.add('hovered');
//     });
//     scrollbar.addEventListener('mouseleave', () => {
//       scrollbar.classList.remove('hovered');
//     });
//   });
// });
// export default App;
import { useState } from 'react';
// import './App.css';
import React from 'react';
import LoginPage from './Component/LoginPage/LoginPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ItemPage from './Component/itemPage/ItemPage';
import Dashboard from './Component/Dashboard/dashboard';
import store from './Component/ReduxStore/store';
import { Provider } from 'react-redux';
import Checkout from './Component/checkout/Checkout';
import LeadgerStatement from './Component/leadgerStatement/LeadgerStatement';
import OutGoingPayment from './Component/OutGoingPayment/outGoingPayment';
import CustomerCreation from './Component/customerCreation/customerCreation';
import Attendance from './Component/attendance/attendance';
import CRM from './Component/crm/crm';
import AutoLogout from './Component/sharedFiles/autoLogout';
import CustomerFollowups from './Component/FollowUps/CustomerFollowups';
import Opportunity from './Component/FollowUps/Opportunity';
import SqHistory from './Component/SQHistory/sqHistory';
import Greeter from './Component/Greeter/Greeter';
import ProtectedRoute from './Component/sharedFiles/Hooks/UseAuth';
import { SharedCrmProvider } from './Component/itemPage/sharedCrmContext';
import { setupApiClient } from './Component/ReduxStore/APIClient/setupApiClient';
// import CustomerFollowups from './Opportunity/OpportunityHistory';




function App() {
  const [databaseName, setDatabaseName] = useState(null); 
  setupApiClient(store);
  return (
    <>
      {/* provide the database name */}
      <Provider store={store}>
  <Router basename="/TpSales">
    <AutoLogout>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/DashBoard" element={<Dashboard />} />
        {/* <Route path="/GetGroupItem" element={<ItemPage />} />
        <Route path="/Checkout" element={<Checkout />} /> */}
          <Route
              path="/GetGroupItem"
              element={
                <SharedCrmProvider>
                  <ItemPage />
                </SharedCrmProvider>
              }
            />
            <Route
              path="/Checkout"
              element={
                <SharedCrmProvider>
                  <Checkout />
                </SharedCrmProvider>
              }
            />
        <Route path="/leadgerStatement" element={<LeadgerStatement />} />
        <Route path="/OutGoingPayment" element={<OutGoingPayment />} />
        <Route path="/CustomerCreation" element={<CustomerCreation />} />
        <Route path="/MarkAttendance" element={<Attendance />} />
        <Route path="/Crm" element={<CRM />} />
        <Route path="/CustomerFollowups" element={<CustomerFollowups />} />
        {/* <Route path="/CustomerFollowups" element={<CustomerFollowups />} /> */}
        <Route path="/Opportunity/:opprId" element={<Opportunity />} />
        <Route path="/SqHistory" element={<SqHistory />} />
      
        <Route element={<ProtectedRoute allowedRoles={["G1"]} />}>
          <Route path="/Greeter" element={<Greeter />} />
        </Route>
      </Routes>
    </AutoLogout>
  </Router>
</Provider>
  </>
  );
}
document.addEventListener('DOMContentLoaded', () => {
  const scrollbars = document.querySelectorAll('::-webkit-scrollbar');
  scrollbars.forEach(scrollbar => {
    scrollbar.addEventListener('mouseenter', () => {
      scrollbar.classList.add('hovered');
    });
    scrollbar.addEventListener('mouseleave', () => {
      scrollbar.classList.remove('hovered');
    });
  });
});
export default App;
